/**
 * Date de la nouveauté la plus récente de data/changelog.js. Seule cette date
 * est dans le bundle principal (la pastille cuivre de l'en-tête en a besoin) ;
 * les textes sont chargés à part. À changer en même temps que l'entrée ajoutée
 * en haut de CHANGELOG — un test vérifie que les deux concordent.
 */
export const CHANGELOG_LATEST_DATE = '2026-10-19';

/**
 * Date de la mise à jour mise en avant par la pop-up « Nouveautés » (SPOTLIGHT
 * de data/changelog.js), ou null pour ne rien montrer. Elle s'affiche une fois
 * par coach, à la première connexion qui suit, et pas aux coachs inscrits après.
 */
export const CHANGELOG_SPOTLIGHT_DATE = '2026-10-19';
